import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=487e9bea"
import script from "./DateRangePicker.vue?vue&type=script&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports